import React from 'react';
import { Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { spacing, borderRadius, fonts } from '../../constants';

/**
 * RaiseNewQueryButton Component
 * Button to navigate to raise new query page
 */
const RaiseNewQueryButton = ({ onClick, fullWidth }) => (
  <Button
    variant="contained"
    startIcon={<AddIcon sx={{ fontSize: { xs: '16px', sm: '18px' } }} />}
    onClick={onClick}
    fullWidth={fullWidth}
    sx={{
      background: 'linear-gradient(135deg, #233491, #2f4ac4)',
      color: '#FFFFFF',
      textTransform: 'none',
      borderRadius: borderRadius.button,
      padding: `${spacing.xs} ${spacing.md}`,
      fontWeight: fonts.weightSemiBold,
      fontSize: fonts.fontSizeSm,
      height: '36px',
      boxShadow: '0 4px 12px rgba(35, 52, 145, 0.35)',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      whiteSpace: 'nowrap',
      flexShrink: 0,
      border: '1px solid transparent',
      '&:hover': {
        background: 'linear-gradient(135deg, #2f4ac4, #233491)',
        boxShadow: '0 6px 16px rgba(35, 52, 145, 0.45)',
        transform: 'translateY(-1px)',
      },
      '&:active': {
        transform: 'translateY(0)',
      },
    }}
  >
    Raise New Query
  </Button>
);

export default RaiseNewQueryButton;
